import React from "react";

import {
    Col,
    Row
} from "react-bootstrap";

import CardPortfolio from "../../components/CardPortfolio";
import constants from "../../lib/constants";

//--
const CompanyPortfolio = (props) => {
    const portfolios = props.data || [];

    const portfolio_items = (portfolios || []).map((p, index) => ({
        id: p.portfolio_id,
        title: p.portfolio_tagline,
        subtitle: p.portfolio_project_category.label,
        price: p.portfolio_project_size?.label,
        img: p.portfolio_image[0] ? `${constants.LOGO_URL}/${p.portfolio_image[0].name}` : `${constants.LOGO_URL}/img_portfolio_0-0.jpg`,
        description: p.portfolio_description
    }))

    const [hoverCard, setHoverCard] = React.useState(null)
    const onCardEnter = (id) => {
        setHoverCard(id)
    }

    const onCardLeave = () => {
        setHoverCard(null)
    }

    return (
        <div id="portfolio" className="text-block">
            <h2 className="mb-4 h4">Portfolio</h2>
            <Row>
                {portfolio_items &&
                    portfolio_items.map((portfolio, ind) => (
                        <Col
                            key={ind}
                            sm="6"
                            lg="4"
                            className="mb-5 hover-animate"
                            onMouseEnter={() => onCardEnter(ind)}
                            onMouseLeave={() => onCardLeave()}
                        >
                            <CardPortfolio
                                data={portfolio}
                                sizes="(max-width:576px) 100vw, (max-width:991px) 50vw, 420px"
                            />
                        </Col>
                    ))}
            </Row>
        </div>
    )
}

export default CompanyPortfolio